import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesInvoice, SalesInvoiceCreate, SalesInvoiceFilter } from '../data/salesInvoice';

export function createSalesInvoiceService(client: AxiosInstance) {
  return createCrudService<SalesInvoice, SalesInvoiceCreate, SalesInvoiceFilter>(
    client,
    '/sales/SalesInvoice',
    'id',
  );
}

export type SalesInvoiceService = CrudService<SalesInvoice, SalesInvoiceCreate, SalesInvoiceFilter>;
